import type { RootState } from 'reducers/rootReducer';
import { Store } from 'redux';

export const storeRegistry: {
    store?: Store<RootState>;
} = {};
